import { render, staticRenderFns } from "./SelectProvider.vue?vue&type=template&id=c3a849c6&"
import script from "./SelectProvider.vue?vue&type=script&lang=js&"
export * from "./SelectProvider.vue?vue&type=script&lang=js&"
import style0 from "./SelectProvider.vue?vue&type=style&index=0&id=c3a849c6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports